import React from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import Section from '../../../shared/Section/Section';
import styles from './styles';
import LocationLabel from '../../../shared/AnimatedLabel/LocationLabel';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../../helpers/myTarget';

function PrecourseIntro({
  title,
  bg,
  theme = 'medium',
  description,
  link,
  metrics,
}) {
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const sendMetrics = () => {
    metrics.ym && sendYandexMetrikaEvent(metrics.ym);
    metrics.mt && sendMyTargetEvent(metrics.mt);
  };
  const inverse = theme === 'medium' ? 'Inverse' : '';

  return (
    <Section
      theme={theme}
      bg={bg}
      position={'right'}
      customStyles={styles.section}
    >
      <Box sx={styles.topBlock}>
        <LocationLabel theme={'default'} type={'online'} title={'онлайн'} />
        <Typography
          variant="desktopP2"
          color={
            theme === 'medium' ? `kit.text.secondaryInverse` : `kit.text.main`
          }
          sx={{ fontSize: { xs: 12, md: 16 } }}
        >
          подготовительная программа
        </Typography>
      </Box>
      <Typography
        variant={isMd ? 'mobileH1' : 'desktopH0'}
        color={`kit.text.main${inverse}`}
        component={'h1'}
        sx={styles.title}
      >
        {title}
      </Typography>
      <Typography
        variant={isMd ? 'mobileP3' : 'desktopP1'}
        color={`kit.text.main${inverse}`}
        component={'h2'}
        sx={styles.description}
      >
        {description}
      </Typography>
      <Link href={link}>
        <Button
          onClick={sendMetrics}
          variant="kitPrimary"
          size={isMd ? 'medium' : 'large'}
          sx={styles.button}
        >
          Купить
        </Button>
      </Link>
    </Section>
  );
}

export default PrecourseIntro;
